import { Link } from "react-router-dom";
import { footerGroups, site } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="mt-auto bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-emotion-laugh-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                {site.brand}
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              {site.description}
            </p>
            <p className="mt-5 flex items-center gap-2 text-xs text-background-400">
              <span className="inline-flex h-4 w-4 items-center justify-center">
                <i className="ri-map-pin-line" />
              </span>
              内容团队常驻线上，欢迎投稿与纠错
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold tracking-wide text-accent-400">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {site.brand}. 内容仅供围观，转载请注明来源。</p>
          <div className="flex items-center gap-4">
            <a
              href={`mailto:${site.email}`}
              rel="nofollow"
              className="whitespace-nowrap transition-colors hover:text-accent-400"
            >
              {site.email}
            </a>
            <span className="whitespace-nowrap">微信：{site.wechat}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}